enum orderActionTypeEnum {
  SEE_DEPOSIT = 1,
  REJECT = 2,
  CONFIRM = 3,
  NULLIFY = 4,
}

export { orderActionTypeEnum }
